import React, { createContext, useContext, useState } from 'react';

interface LayoutContextType {
  isBottomNavVisible: boolean;
  setBottomNavVisible: (visible: boolean) => void;
}

const LayoutContext = createContext<LayoutContextType>({
  isBottomNavVisible: true,
  setBottomNavVisible: () => {},
});

export const LayoutProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isBottomNavVisible, setBottomNavVisible] = useState(true);
  
  return (
    <LayoutContext.Provider value={{ isBottomNavVisible, setBottomNavVisible }}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = () => useContext(LayoutContext);
